import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import {
    answerChangedEvent,
    clearChangeIndicator,
    getSegmentTotals,
    invoiceInit,
    setPriorInvoiceWindowData,
    setTitle,
    showLoaders,
    setOverrideData
} from "./all";
import corporateQuestions, {saveCorporateQuestions} from './corporate-questions'
import getBodySettings from "../../global/page-settings";
import multipleAttachmentSetup from "../../attachments/multiple-attachments";
import projectManagerList, {showNoApprovals, getNoApprovals, approveNothingEvent} from "./project-manager-list";
import _bundle from '../../../core/core--bundles';

const {nameArea, nameController, nameAction, namePage} = getBodySettings('page');

let qid = 0;
let pmNumber = 0;
let isTopList = 0;
let activeTab = 'Incomplete';

export default function (k_quarterSelect, k_pmSelect) {
    attachApplyFilterEvent(k_quarterSelect, k_pmSelect);
    k_quarterSelect.dataSource.bind('requestEnd', e => {
        if (e.response.length > 1) {
            qid = e.response[1].qid;
            k_quarterSelect.value(qid);
            loadSubContractAccrualData();
        }
        k_pmSelect.dataSource.read();
    });
    
    _bundle.add({
       name: 'Accruals: Page Update',
       event: ['on:PageUpdate'],
       fn() {
           const approvalSection = $('#approvals');
           if(activeTab === 'Incomplete' && !isTopList ) {
               approvalSection.hide();
           } else{
               getNoApprovals().then(() => {
                   showNoApprovals();
                   approveNothingEvent();
               });
               approvalSection.show();
           }
       } 
    });

    _bundle.add({
        name: 'Accruals: Change Tabs',
        event: ['on:TabChange'],
        fn() {
            activeTab = $('.menu-topbar__link.--active').text();
            const $applyFilterButton = $('#js-accrual-filter');
            $applyFilterButton.trigger('click');
        }
    });
}

const attachApplyFilterEvent = (k_quarterSelect, k_pmSelect) => {
    let $applyFilterButton = $('#js-accrual-filter');

    if ($applyFilterButton.length) {
        $applyFilterButton.on('click', function () {
            showLoaders();
            qid = k_quarterSelect.value();
            pmNumber = k_pmSelect.value();
            loadSubContractAccrualData();
        });
    }
};

export const loadSubContractAccrualData = (accrualToReopen) => {
    let rx = `/Account/Accruals/SubContractAccrualData?qid=${qid}&pm=${pmNumber}&status=${activeTab}`;
    isTopList = false;
    let rxCallback = function () {
        setPriorInvoiceWindowData();
        setTitle('', false);
        invoiceInit();
        attachSaveEvent();
        attachApprovalEvent();
        attachAccrualBlurEvent();
        attachPercentageBlurEvent();
        attachRejectionEvent();
        answerChangedEvent();
        reopenAccrual(accrualToReopen);
        multipleAttachmentSetup();
        attachReviewResetEvent();
        setWindowData();
        setOverrideData();
        $(document).trigger('on:PageUpdate');
    };
    if (pmNumber === '0' || pmNumber === 0) {
        rx = `/Account/Accruals/SubContractAccrualOverview?qid=${qid}`;
        isTopList = true;
        rxCallback = function () {
            setPriorInvoiceWindowData();
            setTitle('Top Five', true);
            invoiceInit();
            corporateQuestions(qid);
            attachApprovalEvent();
            attachRejectionEvent();
            reopenAccrual(accrualToReopen);
            setOverrideData();
            $(document).trigger('on:PageUpdate');
            projectManagerList(qid);
        }
    }

    $('#projectManager').data('kendoDropDownList').dataSource.read();
    $('.js-accrual-section').load(rx, rxCallback);
};

const attachSaveEvent = () => {
    let $saveButtons = $('[data-role="save"]');
    if ($saveButtons.length) {
        $saveButtons.on('click', function () {
            let $form = $(this).closest('form'),
                accrualId = $form.data('accrual-id'),
                serializedData = $form.serialize(),
                invoiceGrid = $('#invoiceList' + accrualId).data('kendoGrid');
            $.post(`/Account/Accruals/SaveSubContractAccrual?${serializedData.split(`${accrualId}=`).join('=')}`, function (response) {
                if (response === 'SUCCESS') {
                    showSuccessNotification('Accrual Info Saved');
                    clearChangeIndicator();
                } else {
                    showErrorNotification(response);
                }
            });
            if (invoiceGrid.dataSource.hasChanges()) {
                const invData = {};
                const invoices = [];

                invData.qid = qid;
                $.each(invoiceGrid._data, function () {
                    if (this.dirty) {
                        const invoice = {};
                        invoice.ResponsibleParty = this.ResponsibleParty;
                        invoice.InvoiceNumber = this.InvoiceNumber;
                        invoice.Included = this.Included;
                        invoice.InvoiceAmount = this.InvoiceAmount;
                        invoices.push(invoice);
                    }
                });
                invData.invoices = invoices;
                $.post('/Account/Accruals/SubcontractInvoiceUpdate', invData, function (r) {
                    invoiceGrid.dataSource.read();
                });
            }
        });
    }
};

export const attachApprovalEvent = () => {
    let $approvalButtons = $('[data-role="approve"]');
    if ($approvalButtons.length) {
        $approvalButtons.unbind('click');
        $approvalButtons.on('click', function (e) {
            let $self = $(this),
                $form = $(this).closest('form'),
                accrualId = $form.data('accrual-id'),
                approvalAs = $self.data('approve-as'),
                $pin = $self.parent().parent().find(`#pin_id_${approvalAs}`),
                data = {
                    qid: qid,
                    role: approvalAs,
                    pin: $pin.val(),
                    pmNumber: pmNumber === 0 || pmNumber === '0' ? accrualId : pmNumber
                };
            if (isTopList) {
                saveCorporateQuestions($self)
                    .then(() => approveSubContractAccrual(data))
                    .then(() => {
                        loadSubContractAccrualData(accrualId);
                    })
                    .catch((error) => {
                        showErrorNotification(error);
                    });
            } else {
                approveSubContractAccrual(data)
                    .then(() => {
                        loadSubContractAccrualData(accrualId);
                    })
                    .catch((error) => {
                        showErrorNotification(error);
                    });
            }
        });
    }
};

const approveSubContractAccrual = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Account/Accruals/SubContractApproval', data, function (response) {
            if (response === true) {
                resolve();
            } else {
                reject(response);
            }
        });
    })

};

const getCardInfo = ($card) => {
    let $openSubContract = $card.find('.js-open-subcontract'),
        $totalSubContract = $card.find('.js-total-subcontract'),
        $accrualAmount = $card.find('input[id^=DollarAmount]'),
        $percentComplete = $card.find('input[id^=PercentComplete]'),
        k_accrualAmount = $accrualAmount.data('kendoNumericTextBox'),
        k_percentComplete = $percentComplete.data('kendoNumericTextBox'),
        postedInvoices = $totalSubContract.val() - $openSubContract.val();

    return {
        openSubContract: {
            _$: $openSubContract,
            value: $openSubContract.val()
        },
        totalSubContract: {
            _$: $totalSubContract,
            value: $totalSubContract.val()
        },
        accrualAmount: {
            _$: $accrualAmount,
            _k: k_accrualAmount,
            value: k_accrualAmount ? k_accrualAmount.value() : 0.00
        },
        percentComplete: {
            _$: $percentComplete,
            _k: k_percentComplete,
            value: k_percentComplete ? k_percentComplete.value() : 0.00
        },
        postedInvoices: postedInvoices
    }
};

const attachPercentageBlurEvent = () => {
    let $percentCompleteInput = $('input[id^=PercentComplete]');
    $percentCompleteInput.on('blur', function () {
        let cardInfo = getCardInfo($(this).parents('.js-accrual-card')),
            calculatedPercent = cardInfo.percentComplete._$.data('calculated-percent'),
            percentage = Math.min(100, Math.max(calculatedPercent, cardInfo.percentComplete.value)),
            value = (cardInfo.totalSubContract.value * (percentage / 100)) - cardInfo.postedInvoices;

        // Set correct Percentage
        cardInfo.percentComplete._k.value(percentage);
        // Set Accrual Value
        cardInfo.accrualAmount._k.value(calculatedPercent === percentage ? 0.00 : value);
        getSegmentTotals();
    });
};

const attachAccrualBlurEvent = () => {
    let $accrualAmountInput = $('input[id^=DollarAmount]')
    $accrualAmountInput.on('blur', function () {
        let cardInfo = getCardInfo($(this).parents('.js-accrual-card'));
        cardInfo.percentComplete._k.value(((cardInfo.accrualAmount.value + cardInfo.postedInvoices) / (cardInfo.totalSubContract.value)) * 100);
        getSegmentTotals();
    })
};

const attachRejectionEvent = () => {
    let $rejectButton = $('[name=rejectApprovals]');

    if ($rejectButton.length) {
        if (pmNumber === '0' || pmNumber === 0) {
            $rejectButton.on('click', function () {
                let $self = $(this),
                    $form = $self.closest('form'),
                    accrualId = $form.data('accrual-id'),
                    data = {
                        accrualId: accrualId,
                        type: namePage
                    };

                $.post('/Account/Accruals/RejectCorporateQuestions', data, function (response) {
                    if (response === true) {
                        loadSubContractAccrualData(accrualId);
                    } else {
                        showErrorNotification('Failed to Reject Approvals');
                    }
                });
            })
        } else {
            $rejectButton.on('click', function () {
                let $self = $(this),
                    $form = $self.closest('form'),
                    accrualId = $form.data('accrual-id');
                let data = {
                    qid: qid,
                    pmNumber: pmNumber
                };

                $.post('/Account/Accruals/SubContractRejection', data, function (response) {
                    if (response === true) {
                        loadSubContractAccrualData(accrualId);
                    } else {
                        showErrorNotification('Failed to Reject Approvals');
                    }
                });
            })
        }
    }
};

const attachReviewResetEvent = () => {
    let $rejectButton = $('#resetReviewer');

    if ($rejectButton.length) {
        $rejectButton.on('click', function () {
            let $self = $(this),
                $form = $self.closest('form'),
                accrualId = $form.data('accrual-id'),
                data = {
                    qid: qid,
                    pmNumber: pmNumber
                };
            $.post('/Account/Accruals/ResetSubContractReviewer', data, function (response) {
                if (response === true) {
                    loadSubContractAccrualData(accrualId);
                } else {
                    showErrorNotification('Failed to Reset Reviewer');
                }
            });
        })
    }
}

const reopenAccrual = (accrualId) => {
    if (accrualId) {
        $(`[id=Id${accrualId}]`).parents('span.k-link.soxexc__toggle').click();
    }
}

const setWindowData = () => {
    let $modalButton = $('[data-kendoWindow="ChangeOrderWindow"]');

    if ($modalButton.length) {
        $modalButton.on('click', function () {
            let $changeOrderWindow = $('#ChangeOrderWindow'),
                $self = $(this);
            $changeOrderWindow.data('purchase-order', $self.data('purchase-order'));
        });
    }
}